import axios from 'axios';
import { handleUnauthorizedError } from '../utils/HandleUnauthorizedError';
import { clearToken } from './AuthActions';

const isAlertShown = false;

const API = axios.create({
  baseURL: process.env.API_URL,
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearToken();
      handleUnauthorizedError();
      return Promise.reject(error);
    }
    return Promise.reject(error);
  },
);

/**
 *
 */
class BaseAPI {
  /**
   *
   */
  static async getWithAuth(url, query, token) {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: query ? query : {},
    };

    try {
      const response = await API.get(url, config);
      return response.data;
    } catch (err) {
      console.error('API error', err.response.data);
      throw err;
    }
  }

  /**
   *
   */
  static async getWithoutAuth(url, query) {
    const config = {
      params: query ? query : {},
    };

    try {
      const response = await API.get(url, config);
      return response.data;
    } catch (err) {
      console.error('API error', err.response.data);
      throw err;
    }
  }

  /**
   *
   */
  static async post(url, data) {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'text/plain',
        },
      };
      const response = await API.post(url, data, config);
      return response.data;
    } catch (err) {
      console.error('API error', err.response.data);
      throw err;
    }
  }

  /**
   *
   */
  static async postWithAuth(url, data, token) {
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };
    try {
      const response = await API.post(url, data, config);
      return response.data;
    } catch (err) {
      console.error('API error', err.response.data);
      throw err;
    }
  }

  /**
   *
   */
  static async postMutiWithAuth(url, data, token) {
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    };
    const { postData, files } = data;
    const formData = new FormData();

    Object.keys(postData).forEach((key) => {
      if (Array.isArray(postData[key])) {
        formData.append(key, JSON.stringify(postData[key])); // Serialize arrays to JSON
      } else {
        formData.append(key, postData[key]);
      }
    });
    if (files) {
      files.forEach((file) => {
        formData.append('file[]', file);
      });
    }

    try {
      const response = await API.post(url, formData, config);
      return response.data;
    } catch (err) {
      console.error('API error', err.response.data);
      throw err;
    }
  }

  /**
   *
   */
  static async putWithAuth(url, data, token, params) {
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      params: params,
    };
    try {
      const response = await API.put(url, data, config);
      return response.data;
    } catch (err) {
      console.error('API error', err.response.data);
      throw err;
    }
  }
  /**
   *
   */
  static async putMutiWithAuth(url, data, token) {
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    };
    const { putData, files } = data;
    const formData = new FormData();

    Object.keys(putData).forEach((key) => {
      if (Array.isArray(putData[key])) {
        formData.append(key, JSON.stringify(putData[key]));
      } else {
        formData.append(key, putData[key]);
      }
    });

    if (files) {
      files.forEach((file) => {
        formData.append('file[]', file);
      });
    }

    try {
      const response = await API.put(url, formData, config);
      return response.data;
    } catch (err) {
      console.error('API error', err.response.data);
      throw err;
    }
  }

  /**
   *
   */
  static async deleteWithAuth(url, query, token) {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: query ? query : undefined,
    };
    try {
      const response = await API.delete(url, config);
      return response.data;
    } catch (err) {
      console.error('API error', err.response.data);
      throw err;
    }
  }
}

export default BaseAPI;
